export class DataCatalogPipelineOutputPartitionSpecInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "transformType",
            "baseName": "transformType",
            "type": "string",
            "format": ""
        },
        {
            "name": "parameter",
            "baseName": "parameter",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineOutputPartitionSpecInner.attributeTypeMap;
    }
    constructor() {
    }
}
